import { str2svg } from "./utils";
export { str2svg, type IconStyle, type IconName } from "./utils";

export default async function getIcon({style, name}:{style: string, name: string}){
  const res = await fetch(`/_icon/${style}/${name}.svg`)
    .then(response => response.text())
    .catch(reason => {
      console.error(reason);
      return undefined;
    });
  return str2svg(res ?? "");
}